module.exports = __webpack_public_path__ + "img/epicerie-en-ligne-boutrais-medium.8e7239ac.png";